
import AcessosService from "../../services/AcessosService";
import AcessoRegrasService from "../../services/AcessosRegrasService";
import AgendamentoService from "../../services/AgendamentosService";
import AvisosService from "../../services/AvisosService";
import CadastrosService from "../../services/CadastrosInternosService";
import CancelamentosService from "../../services/CancelamentosService";
import ComprasService from "../../services/ComprasService";
import ComprasItensService from "../../services/ComprasItensService";
import DespesasService from "../../services/DespesasService";
import DespesasItensService from "../../services/DespesasItensService";
import DespesasCategoriasService from "../../services/DespesasCategoriasService";
import EspecialidadesService from "../../services/EspecialidadesService";
import EstoqueService from "../../services/EstoqueService";
import FaltasService from "../../services/FaltasService";
import FormapagtoService from "../../services/FormaPagtoService";
import FornecedoresService from "../../services/FornecedoresService";
import FornecedoresCategoriasService from "../../services/FornecedoresCategoriasService";
import HorariosService from "../../services/HorariosService";
import HorariosFechamentosService from "../../services/HorariosFechamentosService";
import MetasService from "../../services/MetasService";
import ProdutosService from "../../services/ProdutosService";
import ProdutosVendasService from "../../services/ProdutosVendasService";
import ReceitasService from "../../services/ReceitasService";
import VendasService from "../../services/VendasService";
import CadastrosInternosService from "../../services/CadastrosInternosService";
import ConfiguracoesService from "../../services/ConfiguracoesService";
import DadosSistemaService from "../../services/DadosSistemaService";



export const serviceMap = {
  dashboard:AgendamentoService,
  acessos: AcessosService,
  acessosregras: AcessoRegrasService,
  permissao:CadastrosInternosService,
  pacotes: AgendamentoService,
  agendamentos: AgendamentoService,
  avisos: AvisosService,
  cadastros: CadastrosService,
  cancelamentos: CancelamentosService,
  compras: ComprasService, 
  compraitens: ComprasItensService, 
  despesas: DespesasService,
  despesasitens: DespesasItensService,
  despesascategorias: DespesasCategoriasService, 
  especialidades: EspecialidadesService,
  estoque: EstoqueService,
  faltas: FaltasService, 
  formapagto: FormapagtoService, 
  fornecedores: FornecedoresService, 
  fornecedorescategorias: FornecedoresCategoriasService, 
  horarios: HorariosService, 
  horariosfechamento: HorariosFechamentosService, 
  metas: MetasService,
  produtos: ProdutosService, 
  produtosvendas: ProdutosVendasService, 
  receitas: ReceitasService, 
  vendas: VendasService,
  configuracoes: ConfiguracoesService,
  dados:DadosSistemaService
};
